import { UploadType } from '@synergy/models';
import { createSelector } from 'reselect';

import { MediaReducerState } from './media-reducers';

const mediaState = (state: { media: MediaReducerState }) => state.media;

const allMediaSelector = createSelector([mediaState], media => media.flat);

export const internalMediaSelector = createSelector([allMediaSelector], media =>
    media.filter(m => m.type === UploadType.Internal)
);

export const priceMatrixMediaSelector = createSelector([allMediaSelector], media =>
    media
        .filter(m => m.type === UploadType.PriceMatrix)
        .sort((a, b) => (b.createdAt && a.createdAt && b.createdAt.getTime() - a.createdAt.getTime()) || -1)
);

export const customerMediaSelector = createSelector([allMediaSelector], media =>
    media.filter(m => m.type === UploadType.Customer)
);

export const supplierMediaSelector = createSelector([allMediaSelector], media =>
    media.filter(m => m.type === UploadType.Supplier)
);
